import { ListResponseModel, toQueryString } from ".";
import { NewUtilityTeamMember, ResendInvite, UtilityTeamMember } from "../model/utility-users/utility-team-member";
import { apiSlice } from "../stores/base/api-slice";

const utilityUsersEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({

		getUtilityUsers: builder.query<Array<UtilityTeamMember>, void>({
			query: () => ({
				url: `/user/utility-users/get-utility-users`,
				method: "GET",
			}),
			providesTags: ["UtilityUsers"],
		}),
		getUtilityUsersPage: builder.query<ListResponseModel<Array<UtilityTeamMember>>, {
			Page: number;
			PageSize: number;
			search?: string;
		}>({
			query: (params) => ({
				url: `/user/utility-users/page`,
				method: "GET",
				params,
			}),
			providesTags: ["UtilityUsers"],
		}),
		getInvitedUtilityUsersPage: builder.query<ListResponseModel<Array<UtilityTeamMember>>, {
			Page: number;
			PageSize: number;
			search?: string;
		}>({
			query: (params) => ({
				url: `/user/utility-users/invited/page`,
				method: "GET",
				params,
			}),
			providesTags: ["UtilityUsers"],
		}),
		deleteTeamMember: builder.mutation<void, string>({
			invalidatesTags: ["UtilityUsers"],
			query: id => ({
				url: `/user/utility-users/deletion/${id}`,
				method: "DELETE"
			}),
		}),
		deleteTeamMemberInvite: builder.mutation<void, string>({
			invalidatesTags: ["UtilityUsers"],
			query: id => ({
				url: `/user/utility-users/deletion/invited/${id}`,
				method: "DELETE"
			}),
		}),
		editTeamMember: builder.mutation<void, NewUtilityTeamMember>({
			invalidatesTags: ["UtilityUsers"],
			query: data => ({
				url: "/user/utility-users/edit-utility-user",
				method: "POST",
				body: data,
			}),
		}),
		inviteTeamMember: builder.mutation<void, NewUtilityTeamMember>({
			invalidatesTags: ["UtilityUsers"],
			query: data => ({
				url: "/user/utility-users/registration/initiate",
				method: "POST",
				body: data,
			}),
		}),
		resendInviteTeamMember: builder.mutation<void, ResendInvite>({
			invalidatesTags: ["UtilityUsers"],
			query: data => ({
				url: "/user/utility-users/registration/resend",
				method: "POST",
				body: data,
			}),
		}),
	}),
});

export const {
	useGetUtilityUsersQuery,
	useLazyGetUtilityUsersPageQuery,
	useLazyGetInvitedUtilityUsersPageQuery,
	useDeleteTeamMemberMutation,
	useEditTeamMemberMutation,
	useInviteTeamMemberMutation,
	useDeleteTeamMemberInviteMutation,
	useResendInviteTeamMemberMutation
} = utilityUsersEndpoints;
